export const bigQueryFilterOperators = {
  acceptedStringOperators: [
    'contains',
    'doesNotContain',
    'equals',
    'doesNotEqual',
  ],
  acceptedNumericOperators: ['=', '!=', '>', '>=', '<', '<='],
  acceptedDateOperators: ['after', 'onOrAfter', 'before', 'onOrBefore'],
};
